import { useEffect, useState } from 'react';
import { apiClient } from '../../../shared/api/apiClient';

/* eslint-disable react-hooks/set-state-in-effect */
// Hook para cargar y persistir las preferencias de vista de tareas (pestaña y filtro de tiempo)
// en la tabla `customs`.
export function useTaskViewPrefs(userDbId) {
    const [savedView, setSavedView] = useState(null);
    const [savedTime, setSavedTime] = useState(null);
    const [hasLoadedCustom, setHasLoadedCustom] = useState(false);

    useEffect(() => {
        if (!userDbId) {
            setHasLoadedCustom(true);
            return;
        }

        Promise.all([
            apiClient.get(`/api/customs/${userDbId}/task_view_mode`),
            apiClient.get(`/api/customs/${userDbId}/task_time_range`)
        ]).then(([viewRes, timeRes]) => {
            if (viewRes.success && viewRes.value) {
                setSavedView(viewRes.value);
            }
            if (timeRes.success && timeRes.value) {
                setSavedTime(timeRes.value);
            }
        }).catch(() => {
            // Ignorar errores, simplemente usar defaults
        }).finally(() => {
            setHasLoadedCustom(true);
        });
    }, [userDbId]);

    const saveViewPref = (viewMode) => {
        if (userDbId) {
            apiClient.post('/api/customs', { userId: userDbId, key: 'task_view_mode', value: viewMode });
        }
    };

    const saveTimePref = (timeRange) => {
        if (userDbId) {
            apiClient.post('/api/customs', { userId: userDbId, key: 'task_time_range', value: timeRange });
        }
    };

    return { savedView, savedTime, hasLoadedCustom, saveViewPref, saveTimePref };
}
